var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.418 12c2.358-.449 4.14-2.512 4.14-4.991 0-2.81-2.284-5.086-5.102-5.086H4.442c0 4.955 3.555 9.08 8.26 9.984h-8.26v10.17c4.97 0 9.107-3.544 10.014-8.235v8.236c2.818 0 5.102-2.277 5.102-5.087a5.087 5.087 0 00-4.14-4.99z",
    fill: "#0A59FF"
  })));
}
export default SvgBlank;